import React from "react";
import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const WrapperTemplate = styled.span`
  ${({ theme, displayState }) => css`
    display: inline-block;
    font-weight: 400;
    font-size: 20px;
    line-height: 144%;
    color: ${displayState?.color ?? theme?.colour?.secondary ?? "#04333B"};
  `}
`;

const ButtonTemplate = styled.span`
  ${({ theme, displayState }) => css`
    display: inline-block;
    margin-left: 8px;
    color: ${displayState?.color ?? theme?.colour?.secondary ?? "#04333B"};
    font-weight: ${displayState?.fontWeight ? displayState?.fontWeight : "600"};
    font-size: ${displayState?.fontSize
      ? displayState?.fontSize
      : displayState?.mobileSmall
      ? "12px"
      : "16px"};
    text-decoration: underline;
    text-align: center;
    padding: 0px;

    cursor: pointer;

    &:active {
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    &:hover {
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    ${displayState?.disabled &&
    css`
      cursor: not-allowed;
      color: ${theme?.colour?.secondary ?? "#04333B"};
      opacity: 0.4;
    `}

    @media only screen and (min-width: 768px) {
      font-size: ${displayState?.fontSize
        ? displayState?.fontSize
        : displayState?.small
        ? "12px"
        : "14px"};
    }
  `}
`;

const Component = (props) => {
  const { message, buttonText, onClick, color, fontWeight, fontSize } = props;
  const handleClick = () => {
    onClick();
  };
  return (
    <WrapperTemplate displayState={{ color, fontWeight, fontSize }}>
      {message}
      <ButtonTemplate
        onClick={handleClick}
        displayState={{ color, fontWeight, fontSize }}
      >
        {buttonText}
      </ButtonTemplate>
    </WrapperTemplate>
  );
};

export const SecondaryMessageAtom = Atom({
  type: "custom",
  dataType: "string",
  template: Component,
});
